import styled from "styled-components";
import { COLORS, SIZES, WEIGHT } from "../../../../layout/theme";

export const ContainerDiv = styled.div`
	width: 100%;
	height: 500px;
	overflow: auto;

	scrollbar-width: auto;
	scrollbar-color: ${COLORS.Grey} ${COLORS.White};

	::-webkit-scrollbar {
		width: 7px;
	}

	::-webkit-scrollbar-track {
		background: ${COLORS.White};
	}

	::-webkit-scrollbar-thumb {
		background-color: ${COLORS.Grey};
		border-radius: 10px;
		border: 2px solid ${COLORS.White};
	}

	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;
export const CartDelete = styled.div`
	color: ${COLORS.Grey};
	font-family: sans-serif;
	font-stretch: ultra-expanded;
	font-size: ${SIZES.level12};
	font-weight: ${WEIGHT.Bold};
`;

export const Container = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;
